import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
  useEffect
} from "react";
import i18next, { changeLanguage } from "i18next";

export type SupportedLanguages = "en" | "fr";
export enum Language { EN = "en", FR = "fr", };
export enum Region { US = "us", FR = "fr" };
export enum Locale { US = `${Language.EN}-US`, FR = `${Language.FR}-FR` };

interface ILanguage {
  language: SupportedLanguages;
  setLanguage: Dispatch<SetStateAction<SupportedLanguages>>;
}

export const LanguageContext = createContext<ILanguage>({
  language: Language.EN,
  setLanguage: () => null,
});

const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const { language: iLang } = i18next;
  const browserLang = iLang.split("-")[0];

  const region = import.meta.env.VITE_REGION || Region.US;
  const defaultLang:SupportedLanguages = region === Region.US || browserLang === Language.EN ? Language.EN : Language.FR;

  const [language, setLanguage] = useState<SupportedLanguages>(defaultLang);

  useEffect(() => {
      setLanguage(defaultLang);
      changeLanguage(defaultLang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
